import React from "react";
import { UserProfileForm } from "../../../components/admin/Dashboard/profile/UserProfileForm";
import { ProfileSettings } from "../../../components/admin/Dashboard/profile/ProfileSettings";

const Profile = () => {
  return (
    <>
        <UserProfileForm />
    </>
  );
};

export default Profile;
